import {Grid} from "@leap4/frontend";
import {Route, Switch} from "react-router-dom";
import {urlService} from "../routing/urlsService";
import UsersPage from "../users/Users/UsersDashboardModule";
import React from "react";
import {editUser} from "./User/edit/EditUser";
import {AddUser} from "./AddEditUser/AddUser";

function UsersModule() {

    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.users()} component={UsersPage}/>
                <Route exact path={urlService.editUsers()} component={editUser}/>
                <Route exact path={urlService.addUser()} component={AddUser}/>
            </Switch>
        </Grid>
    )
}


export default UsersModule